export type OrderDeadlines = { normal: string; bauhof: string };
type OrderMaterial = { article?: { bauhof?: number } | null; additionalArticles?: { deleted?: boolean; article?: { bauhof?: number } | null }[] };

export function isBauhofOrder(order: OrderMaterial): boolean {
  return (order.article?.bauhof ?? 0) > 0 && (order.additionalArticles ?? []).every((extra) => extra.deleted || (extra.article?.bauhof ?? 0) > 0);
}

export function orderWindow(ends: OrderDeadlines | undefined, now = Date.now()): "normal" | "bauhof" | "closed" {
  if (!ends) return "closed";
  if (now < Date.parse(ends.normal)) return "normal";
  if (now < Date.parse(ends.bauhof)) return "bauhof";
  return "closed";
}

export function formatOrderDeadline(deadline: string | undefined): string {
  const timestamp = Date.parse(deadline ?? "");
  if (!Number.isFinite(timestamp)) return "";
  return new Intl.DateTimeFormat("de-DE", {
    timeZone: "Europe/Berlin",
    hour: "2-digit",
    minute: "2-digit",
  }).format(timestamp);
}
